module.exports = __webpack_public_path__ + "media/img/event/logo/oic-7537869e76d1ab842219fa5f8a94da28.jpg";